export default {
    key: 'theme-default',
    name: '默认主题',
    version: '0.0.1',
    author: 'Gang Zhuo'
};